import { useState } from "react";
import { useCreateOrgClient } from "src/services/admin/commands/organizations";
import SnackbarUtils from "src/utils/SnackbarUtils";

export default function useCreateClient() {
	const [isLoading, setIsLoading] = useState(false);

	const { mutate } = useCreateOrgClient();

	const onCreateClient = (clientName: string, email: string) => {
		setIsLoading(true);
		mutate(
			{ clientName, email },
			{
				onSuccess: () => {
					setIsLoading(false);
					SnackbarUtils.success("Se ha creado con éxito tu cliente.");
				},
				onError: () => {
					setIsLoading(false);
					SnackbarUtils.error("Se ha producido un error al intentar crear tu cliente.");
				}
			}
		);
	};

	return { onCreateClient, isLoading };
}
